import { TanStackDevtools } from "@tanstack/react-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";
import { Toaster } from "sonner";
import { Pending } from "@/components/Pending";
import { useProdMode } from "@/hooks/use-prod-mode";
import type { TRPC } from "@/lib/trpcClient";

export type RouterContext = {
  queryClient: QueryClient;
  trpc: TRPC;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  pendingComponent: Pending,
});

function RootComponent() {
  const prodMode = useProdMode();
  return (
    <Suspense fallback={<Pending />}>
      <Outlet />
      {!prodMode && (
        <TanStackDevtools
          config={{
            hideUntilHover: true,
            position: "top-left",
          }}
          plugins={[
            {
              name: "TanStack Query",
              render: <ReactQueryDevtoolsPanel />,
            },
            {
              name: "TanStack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      )}

      <Toaster
        closeButton
        richColors
        visibleToasts={3}
        icons={{
          loading: (
            <Loader2 className="size-3.5 animate-spin text-neutral-500" />
          ),
        }}
      />
    </Suspense>
  );
}
